import { render, staticRenderFns } from "./configurationNotes.vue?vue&type=template&id=5f3e5ac2&scoped=true"
import script from "./configurationNotes.vue?vue&type=script&lang=js"
export * from "./configurationNotes.vue?vue&type=script&lang=js"
import style0 from "./configurationNotes.vue?vue&type=style&index=0&id=5f3e5ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e5ac2",
  null
  
)

export default component.exports